import { useEffect, useState } from "react";
import { Grid, Tooltip } from "@mui/material";
import { getIcons } from "../../../../utils/messageIcons";
import classes from "./MessageIcons.module.css";
/**
 *
 * @param {Object} filters
 * @param {String} country
 * @returns
 */
const MessageIcons = ({ filters, country }) => {
  const [icons, setIcons] = useState({});

  useEffect(() => {
    getIcons(filters, country).then((icons) => setIcons(icons));
  }, [filters, country]);

  return (
    <Grid
      container
      sx={{ marginLeft: "20px" }}
      alignItems="center"
      columnSpacing={1}
    >
      {/* COUNTRY */}
      {icons.country && (
        <Grid item>
          <Tooltip title={country}>
            <img
              src={icons.country}
              loading="lazy"
              alt="messageIcon"
              className={classes.country}
            />
          </Tooltip>
        </Grid>
      )}

      {/*CHARGE MESSAGE */}
      {icons.chargeMessage && (
        <Grid item>
          <Tooltip title={filters.chargeMessage}>
            <img src={icons.chargeMessage} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}

      {/*GENERATION TYPE */}
      {icons.generationType && (
        <Grid item>
          <Tooltip title={filters.generationType}>
            <img src={icons.generationType} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}

      {/*MESSAGE STATUS */}
      {icons.messageStatus && (
        <Grid item>
          <Tooltip title={filters.messageStatus}>
            <img src={icons.messageStatus} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}

      {/*GPI STATUS */}
      {icons.gpiStatus && (
        <Grid item>
          <Tooltip title={filters.gpiStatus}>
            <img src={icons.gpiStatus} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}

      {/*ROUTING TYPE */}
      {icons.routingType && (
        <Grid item>
          <Tooltip title={filters.routingType}>
            <img src={icons.routingType} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}

      {/*STATE */}
      {icons.state && (
        <Grid item>
          <Tooltip title={filters.state}>
            <img src={icons.state} loading="lazy" alt="messageIcon" />
          </Tooltip>
        </Grid>
      )}
    </Grid>
  );
};

export default MessageIcons;
